export interface Crumb {
  label: string;
  onClick?: () => void;
}

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex min-w-0 max-w-full flex-wrap items-center gap-1 text-[13px] text-zinc-500" aria-label="Breadcrumb">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            {i > 0 && (
              <svg className="h-3.5 w-3.5 text-zinc-300" viewBox="0 0 20 20" fill="currentColor">
                <path d="M7.5 5l5 5-5 5V5z" />
              </svg>
            )}
            {last || !c.onClick ? (
              <span className={`max-w-[12rem] truncate ${last ? "font-medium text-zinc-900" : ""}`}>{c.label}</span>
            ) : (
              <button onClick={c.onClick} className="max-w-[12rem] truncate transition-colors hover:text-zinc-900">
                {c.label}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
